import SchemaFormatBox from '@/components/_common/SchemaForm/SchemaFormatBox';
import { ProfileChip } from '@/components/OrderPlacement/OPStep1OrderDetails/OPProfileDetailsOutput';

type MediaBoxProps = {
  value: string;
};

const MediaBox = ({ value }: MediaBoxProps) => {
  return <SchemaFormatBox label="media">{value && <ProfileChip isSchema color="primary" label="Resolution" value={value} />}</SchemaFormatBox>;
};

export default MediaBox;
